import React from "react";
import { View, ActivityIndicator, StyleSheet } from "react-native";
import GlobalStyles from "./StylenColor"; // Adjust the path as necessary

const Loader = () => (
  <View style={styles.loaderContainer}>
    <ActivityIndicator size="large" color="#6200EE" />
  </View>
);

const styles = StyleSheet.create({
  loaderContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: GlobalStyles.GlobalBg.backgroundColor,
  },
});

export default Loader;
